import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=eb180718&scoped=true&"
import script from "./ItemForm.vue?vue&type=script&lang=js&"
export * from "./ItemForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=eb180718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb180718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb180718')) {
      api.createRecord('eb180718', component.options)
    } else {
      api.reload('eb180718', component.options)
    }
    module.hot.accept("./ItemForm.vue?vue&type=template&id=eb180718&scoped=true&", function () {
      api.rerender('eb180718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "backoffice/themes/base/src/components/FormModal/ItemForm.vue"
export default component.exports